import React, { useState, useEffect } from "react";
import "./PageConfirmation.css";
import { Button, Form } from "react-bootstrap";
import SignUp from "../../Login/SignUp/SignUp";
import StepperComponent from "../Stepper/Stepper";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
const PageConfirmation = (props) => {
  useEffect(() => {
    handleNext();
  });
  const [activeStep, setActiveStep] = useState(0);
  const handleNext = () => {
    setActiveStep(2);
  };

  return (
    <>
      <Navbar />
      <div className="confirmer container">
        <h2>Prise de rendez-vous en ligne</h2>
        <hr />
        <StepperComponent activeStep={activeStep} />
        <div className="parent">
          <div className="div1">
            <h5>Récapitulatif</h5>
            <p>Vous avez pré-réservé un rendez-vous.</p>

            <div className="d-inline-flex">
              <div className="card1">
                <strong>Date :</strong>
                <p>jeudi, le 12 novembre 2020 à 8 h 20</p>
                <strong>Lieu :</strong>
                <p>Prélévement au Laboratoire</p>
                <p>
                  Prix estimé :<strong> 59,00 DH</strong>
                </p>
              </div>
              <div className="card2">
                <h5>Nos services sont remboursés, n'attendez pas.</h5>
                <p>
                  Nos services sont remboursés par la plupart des régimes
                  d'assurance collective et privée. Renseignez-vous auprès de
                  votre assureur.
                </p>
              </div>
            </div>
            <p>* Prix sujet à confirmation lors de votre rendez-vous</p>
            <p>Modes de paiement acceptés ; Visa, MasterCard</p>
            <br />
            <br />
            <br />
            <br />
            <h6>Analyses demandées</h6>
            <ul style={{ listStyleType: "square" }}>
              <li>Covid (pré-op)</li>
            </ul>
          </div>
          <div className="div2">
            <h5>Confirmation du rendez-vous</h5>
            <p>
              Les informations suivantes sont nécessaires pour finaliser la
              réservation :
            </p>
            <div className="signup">
              <SignUp />
              <Form.Check
                className="checkbox"
                type="checkbox"
                label="J'ai pris connaissance du prix, j'accepte la politique de vie privée et les modalités d'utilisation du site  www.site.labo.com"
              />

              <Link to="pageend">
                <Button className="btn">Confirmer le rendez-vous</Button>
              </Link>
            </div>
            <p>ous les champs sont obligatoires</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageConfirmation;
